import { db } from './firebase';
import { doc, increment, setDoc } from 'firebase/firestore';

export async function trackPageView(type: 'post' | 'category' | 'page' | 'home', id?: string, title?: string) {
    const now = new Date();
    // adjust to desired timezone if necessary, using UTC for simplicity
    const yyyyMmDd = now.toISOString().split('T')[0]; 
    const yyyyMm = yyyyMmDd.substring(0, 7);

    try {
        // Track overall
        await Promise.all([
            setDoc(doc(db, 'analytics_daily', yyyyMmDd), { views: increment(1) }, { merge: true }),
            setDoc(doc(db, 'analytics_monthly', yyyyMm), { views: increment(1) }, { merge: true }),
            setDoc(doc(db, 'analytics_all_time', 'total'), { views: increment(1) }, { merge: true })
        ]);

        // Track specific
        if (type === 'post' && id && title) {
            await setDoc(doc(db, 'post_stats', id), { title, views: increment(1) }, { merge: true });
        } else if (type === 'category' && title) {
            // Encode category title for document ID to be safe
            const safeTitle = encodeURIComponent(title);
            await setDoc(doc(db, 'category_stats', safeTitle), { title, views: increment(1) }, { merge: true });
        } else if (type === 'page' && id && title) {
            await setDoc(doc(db, 'page_stats', id), { title, views: increment(1) }, { merge: true });
        }
    } catch(e) {
        console.error("Failed to track view", e);
    }
}
